import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeAuthenticatorOptionComponent } from './change-authenticator-option.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    ChangeAuthenticatorOptionComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule
  ]
})
export class ChangeAuthenticatorOptionModule { }
